<template>
    <div id="permit_type_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="vehiclePermitTypeHeader" v-if="$route.params.id > 0">Update Asset Permit Type</span>
                    <span class="page-title" id="vehiclePermitTypeHeader" v-else>Add Asset Permit Type</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackVehiclePermitTypesList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="vehiclePermitTypeForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Name:</label>
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Name" name="name">
                                        <div class="field-error">{{name_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="description">Description:</label>
                                        <input type="text" class="form-control" v-model="description" id="description" placeholder="Enter Description" name="description">
                                        <div class="field-error">{{description_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label">Effective Date</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="effective_date" name="effective_date" v-model="effective_date" :config="optionsDate" aria-describedby="basic-addon3" class="cal-icon"></date-picker>
                                            <label for="effective_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                        <div class="field-error">{{effective_date_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label">Expiry Date</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="expiry_date" name="expiry_date" v-model="expiry_date" :config="optionsDate" aria-describedby="basic-addon3" class="cal-icon"></date-picker>
                                            <label for="expiry_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                        <div class="field-error">{{expiry_date_error_msg}}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label" for="Amount">Amount:</label>
                                        <input type="text" class="form-control"
                                        v-model="amount" 
                                        @blur="amount = leaveFocus($event)"
                                        @focus="amount = enterVal($event)"
                                        @input="validateInput"
                                        id="Amount" placeholder="Enter Amount" name="Amount" @keypress="isAmountCheck($event)">
                                        <div class="field-error">{{amount_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="vehicle_id">Licence Type:</label>
                                        <v-select v-model="licence_type" name="vehicle_id"
                                            label="text" :options="licenceArr"
                                            placeholder="Select Permit Type" class="custom-ci-auto-search">
                                        </v-select>
                                        <div class="field-error">{{ licence_type_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="vehicle_id">Reportable:</label>
                                        <v-select v-model="reportable" name="owner"
                                            label="text" :options="reportArr"
                                            placeholder="Reportable" class="custom-ci-auto-search">
                                        </v-select>
                                        <div class="field-error">{{ report_error_msg }}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="AdminFee">Admin Fee:</label>
                                        <input type="text" class="form-control"
                                        v-model="admin_fee"
                                        id="AdminFee" placeholder="Enter Admin Fee" name="AdminFee" @keypress="isAmountCheck($event)">
                                        <div class="field-error">{{admin_fee_error_msg}}</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createVehiclePermitTypeBtn" class="btn btn-primary" v-if="$route.params.id > 0" v-on:click.prevent="CreateVehiclePermitType" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createVehiclePermitTypeBtn" class="btn btn-primary" v-else v-on:click.prevent="CreateVehiclePermitType" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueVehiclePermitTypeBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateVehiclePermitType(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelPermitTypeBtn" class="btn btn-tertiary" v-on:click.prevent="BackVehiclePermitTypesList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';


export default {
  name: "VehiclePermitTypesCreate",
  
  mixins:[commonMixins],
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Asset Permit Type | " +process.env.COPYRIGHT_NAME : "Create Asset Permit Type | " +process.env.COPYRIGHT_NAME}
  },
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    name: "",
    optionsDate: {
        format: 'MM/DD/YYYY',
        useCurrent: false,
    },
    description: "",
    state: null,
    stateArr: [],
    loading:false,
    name_error_msg: "",
    state_error_msg:"",
    description_error_msg: "",
    amount:"",
    effective_date:"00/00/0000",
    expiry_date:"00/00/0000",
    amount_error_msg:"",
    expiry_date_error_msg:"",
    effective_date_error_msg:"",
    licence_type:'',
    licence_type_error_msg:'',
    licenceArr:[{value:'Full Plated',text:'Full Plated'}
    ,{value:'Prorate',text:'Prorate'}],
    reportable:'',
    reportArr:[{value:'Yes',text:'Yes'},
    {value:'No',text:'No'}],
    report_error_msg:'',
    admin_fee: '',
    admin_fee_error_msg: '',
  }),
  watch: {
        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_asset_permit_type') {
                        self.cantAccessPage = true;

                    }
                }
            }

        }
  },
  created: function() {

  },
  mounted: function() {
    var self = this;
    self.getPermissions();

    var path = window.location.pathname;
    var segments = path.split("/");

    if (segments[3]) {
        self.loadPermitType();
    }
  },
  methods: {
    validateInput(evt) {
      var self = this;
      evt = (evt) ? evt : window.event;
      if(evt.target.value > 999999.99) {
        self.amount_error_msg = "Amount value exceed";
      } else {
        self.amount_error_msg = "";
      }
    },
      // enterVal:function(evt) {
      //   evt = (evt) ? evt : window.event;
      //   console.log("ENTER  ==", evt.target.value);
      //   this.amount = evt.target.value;
      //   this.amount = evt.target.value.replace(/\,/g,"");
      // },
      // leaveFocus:function(evt) {
      //   evt = (evt) ? evt : window.event;
      //   console.log("focus ==", evt.target.value);
      //   this.amount =  this.amountFormat(evt.target.value);
      // },
      amountFormat(amount) {
          const formatter = new Intl.NumberFormat('en-US', {
              minimumFractionDigits:2,
              maximumFractionDigits:2
          });

          return formatter.format(amount);
      },

    onSearchState(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'state', '');
        }
    },

    BackVehiclePermitTypesList(){
        var self = this;
        self.$router.push("/vehiclepermittype/list");
    },

    CreateVehiclePermitType(flag){

        var self = this;
        var error = false;

        self.name_error_msg = "";
        self.description_error_msg = "";
        self.state_error_msg = "";
        self.effective_date_error_msg = "";
        self.expiry_date_error_msg = "";
        self.admin_fee_error_msg = "";

        if (!self.name || self.name == null || self.name == "") {
            self.name_error_msg = "Name Required.";
            error = true;
        }

        if (!self.description || self.description == null || self.description == "") {
            self.description_error_msg = "Description Required.";
            error = true;
        }

        if (self.expiry_date && new Date(self.expiry_date) < new Date(self.effective_date)) {
            self.expiry_date_error_msg = "Expiry Date Should Be Greater Than Effective Date.";
            error = true;
        }

        if(self.admin_fee === 0){
        }else{
            if(!self.admin_fee || self.admin_fee == null || self.admin_fee == ""){
                self.admin_fee_error_msg = "Admin Fee Required.";
                error = true;
            }
        }

        if (!error) {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createVehiclePermitTypeBtn").val("Updating ...");
                $("#createVehiclePermitTypeBtn").prop("disabled", true);
                $("#cancelPermitTypeBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueVehiclePermitTypeBtn").val("Saving ...");
                    $("#createVehiclePermitTypeBtn").prop("disabled", true);
                    $("#createAndContinueVehiclePermitTypeBtn").prop("disabled", true);
                    $("#cancelPermitTypeBtn").prop("disabled",true);

                }else{

                    $("#createVehiclePermitTypeBtn").val("Saving ...");
                    $("#createVehiclePermitTypeBtn").prop("disabled", true);
                    $("#createAndContinueVehiclePermitTypeBtn").prop("disabled", true);
                    $("#cancelPermitTypeBtn").prop("disabled",true);
                }

            }

            var fields = $("#vehiclePermitTypeForm").serializeArray();
            // .replace(/\,/g,"")
            var idx = fields.findIndex(obj => obj.name == 'Amount');
            if (idx != -1) {
              fields.push({
                  name: "Amount",
                  value: fields[idx].value.replace(/\,/g,"")
              });
              fields.splice(idx, 1);
            }
            fields.push({name: "name", value: self.name});
            if (self.state == null || !self.state.value) {
                fields.push({name: "state_id", value: null});
            } else {
                fields.push({name: "state_id", value: self.state.value});
            }
            fields.push({name: "description", value: self.description});
            fields.push({name: "id", value: segments[3]});
            if(self.licence_type == null){
                fields.push({name: "licence_type", value: ""});
            }else{
                fields.push({name: "licence_type", value: self.licence_type.value});
            }

            if(self.reportable == null){
                fields.push({name: "reportable", value: ""});
            }else{
                fields.push({name: "reportable", value: self.reportable.value});
            }
            fields.push({name: "admin_fee", value: self.admin_fee});

            $.ajax({
                url: process.env.ROOT_API + "/vehiclepermittype/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createVehiclePermitTypeBtn").val("Update");
                        $("#createVehiclePermitTypeBtn").prop("disabled", false);
                        $("#cancelPermitTypeBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueVehiclePermitTypeBtn").val("Save and Continue");
                            $("#createVehiclePermitTypeBtn").prop("disabled", false);
                            $("#createAndContinueVehiclePermitTypeBtn").prop("disabled", false);
                            $("#cancelPermitTypeBtn").prop("disabled",false);

                        }else{

                            $("#createVehiclePermitTypeBtn").val("Save");
                            $("#createVehiclePermitTypeBtn").prop("disabled", false);
                            $("#createAndContinueVehiclePermitTypeBtn").prop("disabled", false);
                            $("#cancelPermitTypeBtn").prop("disabled",false);

                        }
                    }
                    if( data.code == 201){

                        $("#errorMsg").html(data.message);
                        $(".alert-warning").toggleClass("show");
                        setTimeout(function () {
                            $(".alert-warning").removeClass("show");
                            $(".alert-warning").addClass("hide");
                        }, 10000);

                    }else if (data.code == 200) {

                        if (flag == "Save and Continue") {

                            $("#vehiclePermitTypeForm").trigger("reset");
                            self.name ="";
                            self.state = null;
                            self.description = "";
                            self.amount = "";
                            self.reportable = '';
                            self.licence_type = '';

                        }else{
                            self.$router.push("/vehiclepermittype/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createVehiclePermitTypeBtn").val("Update");
                        $("#createVehiclePermitTypeBtn").prop("disabled", false);
                        $("#cancelPermitTypeBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#vehiclePermitTypeForm").trigger("reset");


                            $("#createAndContinueVehiclePermitTypeBtn").val("Save and Continue");
                            $("#createVehiclePermitTypeBtn").prop("disabled", false);
                            $("#createAndContinueVehiclePermitTypeBtn").prop("disabled", false);
                            $("#cancelPermitTypeBtn").prop("disabled",false);

                        }else{

                            $("#createVehiclePermitTypeBtn").val("Save");
                            $("#createVehiclePermitTypeBtn").prop("disabled", false);
                            $("#createAndContinueVehiclePermitTypeBtn").prop("disabled", false);
                            $("#cancelPermitTypeBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'permit-type-create')
                }
            });

        }else{
          self.errorValidationFocus();
        }

    },

    loadPermitType(){
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/vehiclepermittype/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    self.name = data.content.type;
                    self.description = data.content.description;
                    self.effective_date = data.content.effective_date;
                    self.expiry_date = data.content.expiry_date;
                    self.amount = self.amountFormat(data.content.amount);
                    self.licence_type = {text:data.content.license_type,value:data.content.license_type};
                    self.reportable = {text:data.content.reportable,value:data.content.reportable};
                    self.admin_fee = data.content.admin_fee;
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'permit-type-by-id')
            }
        });
    }


  }
}
</script>




// WEBPACK FOOTER //
// src/components/VehiclePermitTypesCreate.vue